export const fetchAuditableOrder = async () => {
  return await window.$vue.$post({ endpoint: "/bko" })
}

export const fetchAuditableOrderByUuid = async uuid => {
  return await window.$vue.$post({ endpoint: `/bko/${uuid}` })
}

export const fetchViewOrderByUuid = async uuid => {
  return await window.$vue.$get({ endpoint: `/sale/${uuid}` })
}

export const fetchCreditAnalysisInformationPerSale = async uuid => {
  return await window.$vue.$get({ endpoint: `/credit/${uuid}` })
}

export const fetchCancelReasons = async params => {
  return await window.$vue.$get({ endpoint: `/credit/cancel-reasons`, params })
}

export const fetchBiometricData = async uuid => {
  return await window.$vue.$get({ endpoint: `/biometry/${uuid}` })
}

export const resendBiometry = async (uuid, data) => {
  return await window.$vue.$post({
    endpoint: `/biometry/${uuid}/resend-biometry`,
    data
  })
}

export const updateBiometryStatus = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/bko/${uuid}/biometry`,
    data
  })
}

export const setPendency = async (uuid, data) => {
  return await window.$vue.$post({
    endpoint: `/bko/${uuid}/pending`,
    data
  })
}

export const saveNote = async (uuid, data) => {
  return await window.$vue.$post({
    endpoint: `/sale/${uuid}/note`,
    data
  })
}

export const finishAuditorship = async (uuid, data) => {
  return await window.$vue.$put({ endpoint: `/bko/${uuid}`, data })
}

export const editAuditorshipData = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/bko/${uuid}/data`,
    data
  })
}

export const editFinishedOrder = async (uuid, data) => {
  return await window.$vue.$put({
    endpoint: `/bko/${uuid}/finished`,
    data
  })
}

export const fetchStatusCoverageAuditorship = async uuid => {
  return await window.$vue.$post({
    endpoint: `/sale/${uuid}/bko/coverage`
  })
}

export const fetchStatusCreditAuditorship = async (uuid, data) => {
  return await window.$vue.$post({
    endpoint: `/credit/bko/${uuid}/manual`,
    data
  })
}

export const listProfessions = async () => {
  return await window.$vue.$get({
    endpoint: `/person/list-professions`
  })
}

export const exportOrder = async uuid => {
  return await window.$vue.$get({
    endpoint: `/sale/${uuid}/export`,
    responseType: "blob"
  })
}

export const listStatusReasons = async params => {
  return await window.$vue.$get({
    endpoint: "/bko/sale-status-reason",
    params
  })
}

export const checkEmail = async params => {
  return await window.$vue.$get({
    endpoint: "/validation/email/verify",
    params
  })
}

export const getTermsOfUse = async uuid => {
  return await window.$vue.$get({
    endpoint: `/biometry/${uuid}/terms`
  })
}

export const finishIntegrationSale = async (data, uuid) => {
  return await window.$vue.$put({
    endpoint: `/sale/${uuid}/finish-integration`,
    data
  })
}

export const listNoteType = async () => {
  return await window.$vue.$get({ endpoint: "/bko/note-type" })
}

export const listServicesStatus = async () => {
  return await window.$vue.$get({ endpoint: "/service-status-reason/sale-service-status"})
}

export const fetchCoverageDetail = async (uuid) => {
  return await window.$vue.$get({ endpoint: `/sale/${uuid}/coverage-detail` })
}

export const fetchBiometryReasons = async () => {
  return await window.$vue.$get({ endpoint: `/biometry/reasons` })
}

export const fetchStatusNoteType = async () => {
  return await window.$vue.$get({ endpoint: `/bko/status-note-type` })
}

export const updateStatus = async (data) => {
  return await window.$vue.$post({
    endpoint: `/bko/manual-change-status`,
    data
  })
}

export const fetchCreditAnalysisDetails = async (uuid) => {
  return await window.$vue.$get({ endpoint: `/credit/${uuid}/result` })
}

export const fetchOrderCommissions = async (uuid) => {
  return await window.$vue.$get({ endpoint: `/sale/${uuid}/commissions` })
}
